import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Fourchette } from '../models/Fourchette';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
@Component({
  selector: 'app-fourchette',
  templateUrl: './fourchette.component.html'
})
export class FourchetteComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Fourchette'
  @Input() parentForm: FormGroup;
  @Input() fourchette : Fourchette;
  @Input() disabled: boolean;
  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
}

